export const environment = {
  production: true,
  appUrl: 'https://dev-pay.qwiko.app',
  baseUrl: 'https://dev-pay.qwiko.app',
  apiUrl: 'https://dev-api.qwiko.app',
  authUrl: 'https://dev-auth.qwiko.app',
  firebase: {
    apiKey: 'AIzaSyDs3mheNJoLZPR5gxkguOQCVQhzkgHWH28',
    authDomain: 'qwikoappsdev.firebaseapp.com',
    projectId: 'qwikoappsdev',
    storageBucket: 'qwikoappsdev.firebasestorage.app',
    messagingSenderId: '920109618387',
    appId: '1:920109618387:web:b8d236321eb914ebd6b026',
    measurementId: 'G-B9RCJB43EW',
  },
  recaptcha: {
    sitekey: '6LcUASEqAAAAAE1pFahr6PlCGmCyH7nAFtmpx9K_',
  },
  useEmulators: false,
};
